<template>
  <div class="reportBasic1">
    <div class="reportBasic-con">
      <a-tabs defaultActiveKey="1" @change="callback">
        <a-tab-pane
          :tab="$tc('lang.ReportsDetail.GENERAL_INFORMATION')"
          key="1"
        >
          <basic-information />
        </a-tab-pane>
        <a-tab-pane :tab="$tc('lang.ReportsDetail.BULK_SUMMARY')" key="2">
          <description-of-goods />
        </a-tab-pane>
        <a-tab-pane
          :tab="$tc('lang.ReportsDetail.PACKING_INFORMATION')"
          key="3"
        >
          <description-of-pack v-if="orderMouldId != 5" />
          <description-of-pack-batch v-else />
        </a-tab-pane>
        <a-tab-pane :tab="$tc('lang.ReportsDetail.WORKMANSHIP')" key="4">
          <product-process />
        </a-tab-pane>
        <a-tab-pane :tab="$tc('lang.ReportsDetail.Product_Details')" key="5">
          <product-details v-if="orderMouldId != 5" />
          <product-details-batch v-else />
        </a-tab-pane>
        <a-tab-pane :tab="$tc('lang.ReportsDetail.TEST')" key="6">
          <test-data />
        </a-tab-pane>
        <a-tab-pane :tab="$tc('lang.ReportsDetail.DEFECTS_DISPOSAL')" key="7">
          <defective-goods />
        </a-tab-pane>
        <a-tab-pane :tab="$tc('lang.ReportsDetail.Brief_Report')" key="8">
          <general-estimate />
        </a-tab-pane>
      </a-tabs>
    </div>
    <!-- <div class="bottom-active">
      <div>
        <a-button type="primary" @click="goBack">{{
          $tc('lang.ReportsDetail.Return')
        }}</a-button>
      </div>
    </div> -->
  </div>
</template>
<script>
import basicInformation from './components/basicInformation';
import descriptionOfGoods from './components/descriptionOfGoods';
import descriptionOfPack from './components/descriptionOfPack';
import descriptionOfPackBatch from './components/descriptionOfPackBatch';

import productProcess from './components/productProcess';
import productDetails from './components/productDetails';
import productDetailsBatch from './components/productDetailsBatch';

import testData from './components/testData';
import defectiveGoods from './components/defectiveGoods';
import generalEstimate from './components/generalEstimate';

export default {
  data() {
    return {
      id: this.$route.query.id,
      imgList1: {
        productPhoto: [], //产品图片
        cleargovphoto: [], //廉政申明及抽样封箱
        factorycardphoto: [], //厂牌
        remarkphoto: [], //备注图片
        // 货物描述
        descriptionOfGoods: {
          packed: [], //大货箱堆
          unpacked: [], //未入箱成品
          semi: [], //半成品
          sampboxphoto: [], //抽样箱堆
          sampproductphoto: [], //抽样产品
        },
        // 包装描述
        descriptionOfPack: {
          cartonseal: [], //外箱封装方式
          frontmark: [], //外箱正唛
          sidemark: [], //外箱侧唛
          cartonbarcode: [], //外箱条码
          cartonsize: [], //外箱尺寸
          cartonweight: [], //外箱重量（带产品）
          innerpack: [], //开箱后包装
          cartonlayer: [], //外箱瓦楞质量
          packdetail: [], //单件产品包装方式
          innerbox: [], //内盒
          packsize: [], //单件产品包装尺寸
          other: [], //其他
        },
        //产品工艺
        productProcess: {
          front: [], // 正面
          side: [], // 侧面
          back: [], // 背面
          inside: [], // 	内部
          printdetail: [], // 	细节
          productsize: [], //产品尺寸
          contrastphoto: [], //大货与签样对比
        },
        //瑕疵品处理
        defectiveGoods: {
          defectarea: [], //瑕疵品堆放区
          groupphoto: [], //QC、工厂负责人与瑕疵品堆放区合影
          cancel: [], //报废
          rework: [], //返工
        },
      },
      // 模板id
      orderMouldId: '',
    };
  },
  created() {
    this.getDetail();
    this.getImg();
  },
  components: {
    descriptionOfGoods, // 货物描述
    descriptionOfPack, // 包装描述
    productProcess, // 产品工艺
    productDetails, // 产品细节
    testData, //测试数据
    defectiveGoods, // 瑕疵品处理
    basicInformation, // 基本信息
    generalEstimate,
    descriptionOfPackBatch, //总概
    productDetailsBatch,
  },
  computed: {
    details: {
      get() {
        return this.$store.state.report.details;
      },
      set(val) {
        this.$store.commit('report/save', { details: val });
      },
    },
    imgList: {
      get() {
        return this.$store.state.report.imgList;
      },
      set(val) {
        this.$store.commit('report/save', { imgList: val });
      },
    },
  },
  methods: {
    callback(key) {
      console.log(key);
    },
    goBack() {
      this.$router.back(-1);
    },
    // 获取OrderMouldId
    getOrderMouldId(orderId) {
      console.log(orderId);
      this.$http
        .get('/hzwmj/workorder/detail?orderId=' + orderId)
        .then(data => {
          if (data) {
            this.orderMouldId = data.data.order.orderMouldid;
          }
        })
        .catch(() => {});
    },
    getDetail() {
      this.$http
        .get('/hzwmj/workorder-inspectreport/detail', {
          params: {
            id: this.id,
          },
        })
        .then(data => {
          if (data) {
            this.details = data.data;
            this.getOrderMouldId(this.details.orderId);
          } else {
            this.details = {};
          }
        })
        .catch(() => {
          this.details = {};
        });
    },
    getImg() {
      this.$http
        .post('/hzwmj/inspect-media/selDate', {
          reportId: this.id,
        })
        .then(data => {
          if (data) {
            this.ImgClass(data.data);
            // console.log(data);
          } else {
            // this.details = {};
          }
        })
        .catch(() => {
          // this.details = {};
        });
    },
    ImgClass(data) {
      data.forEach(item => {
        console.log('=======', item);
        if (item.mediaDescribe == 'productPhoto') {
          this.imgList1.productPhoto.push(item);
        } else if (item.mediaDescribe == 'cleargovphoto') {
          this.imgList1.cleargovphoto.push(item);
        } else if (item.mediaDescribe == 'factorycardphoto') {
          this.imgList1.factorycardphoto.push(item);
        } else if (item.mediaDescribe == 'remarkphoto') {
          this.imgList1.remarkphoto.push(item);
        } else if (item.mediaDescribe == 'packed') {
          this.imgList1.descriptionOfGoods.packed.push(item);
        } else if (item.mediaDescribe == 'unpacked') {
          this.imgList1.descriptionOfGoods.unpacked.push(item);
        } else if (item.mediaDescribe == 'semi') {
          this.imgList1.descriptionOfGoods.semi.push(item);
        } else if (item.mediaDescribe == 'sampboxphoto') {
          this.imgList1.descriptionOfGoods.sampboxphoto.push(item);
        } else if (item.mediaDescribe == 'sampproductphoto') {
          this.imgList1.descriptionOfGoods.sampproductphoto.push(item);
        } else if (item.mediaDescribe == 'cartonseal') {
          this.imgList1.descriptionOfPack.cartonseal.push(item);
        } else if (item.mediaDescribe == 'frontmark') {
          this.imgList1.descriptionOfPack.frontmark.push(item);
        } else if (item.mediaDescribe == 'sidemark') {
          this.imgList1.descriptionOfPack.sidemark.push(item);
        } else if (item.mediaDescribe == 'cartonbarcode') {
          this.imgList1.descriptionOfPack.cartonbarcode.push(item);
        } else if (item.mediaDescribe == 'cartonsize') {
          this.imgList1.descriptionOfPack.cartonsize.push(item);
        } else if (item.mediaDescribe == 'cartonweight') {
          this.imgList1.descriptionOfPack.cartonweight.push(item);
        } else if (item.mediaDescribe == 'innerpack') {
          this.imgList1.descriptionOfPack.innerpack.push(item);
        } else if (item.mediaDescribe == 'cartonlayer') {
          this.imgList1.descriptionOfPack.cartonlayer.push(item);
        } else if (item.mediaDescribe == 'packsize') {
          this.imgList1.descriptionOfPack.packsize.push(item);
        } else if (item.mediaDescribe == 'innerbox') {
          this.imgList1.descriptionOfPack.innerbox.push(item);
        } else if (item.mediaDescribe == 'packdetail') {
          this.imgList1.descriptionOfPack.packdetail.push(item);
        } else if (item.mediaDescribe == 'other') {
          this.imgList1.descriptionOfPack.other.push(item);
        } else if (item.mediaDescribe == 'front') {
          this.imgList1.productProcess.front.push(item);
        } else if (item.mediaDescribe == 'side') {
          this.imgList1.productProcess.side.push(item);
        } else if (item.mediaDescribe == 'back') {
          this.imgList1.productProcess.back.push(item);
        } else if (item.mediaDescribe == 'inside') {
          this.imgList1.productProcess.inside.push(item);
        } else if (item.mediaDescribe == 'printdetail') {
          this.imgList1.productProcess.printdetail.push(item);
        } else if (item.mediaDescribe == 'productsize') {
          this.imgList1.productProcess.productsize.push(item);
        } else if (item.mediaDescribe == 'contrastphoto') {
          this.imgList1.productProcess.contrastphoto.push(item);
        } else if (item.mediaDescribe == 'defectarea') {
          this.imgList1.defectiveGoods.defectarea.push(item);
        } else if (item.mediaDescribe == 'groupphoto') {
          this.imgList1.defectiveGoods.groupphoto.push(item);
        } else if (item.mediaDescribe == 'cancel') {
          this.imgList1.defectiveGoods.cancel.push(item);
        } else if (item.mediaDescribe == 'rework') {
          this.imgList1.defectiveGoods.rework.push(item);
        }
      });
      this.imgList = this.imgList1;
    },
  },
};
</script>

<style lang="less">
.reportBasic1 {
  margin-top: 50px;
  border-bottom: 1px solid #b4b4b4;
  border-radius: 10px;
  height: calc(100vh - 220px);
  overflow: hidden;
  text-align: left;
  .reportBasic-subTitle {
    background-color: #f6f6f6;
    padding: 5px 10px;
    margin: 10px 0;
  }
  .button-group {
    text-align: right;
    button {
      margin: 0 5px;
    }
  }
  .reportBasic-con {
    .ant-tabs-tabpane {
      padding: 0 10px 30px;
      height: calc(100vh - 300px);
      overflow-y: auto;
    }
  }
}
</style>
